import { ReactElement, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  IAcquisitionCell, IAcquisitionDataSchema,
} from "../types";
import { cloneObject } from "../../../system/utils";
import { useSelector } from "react-redux";
import { ISelectedNode, IState } from "../../../types";
import { getMachinesByNode } from "./utils";
import AcqConfigPanel from "./acqConfigPanel";

interface IProps {
  cell: IAcquisitionCell;
  open: boolean;
  setOpen: (open: boolean) => void;
  schema: IAcquisitionDataSchema;
}


const DialogAcqConfigCell = ({ cell, open, setOpen, schema }: IProps): ReactElement => {
  const selectedNode = useSelector<IState, ISelectedNode>(state => state.selectedNode);
  const [machines] = useState<ISelectedNode[]>(getMachinesByNode(selectedNode));
  const [editableCell, setEditableCell] = useState<IAcquisitionCell>(cloneObject(cell));

  useEffect(() => {
    const newCellData = cloneObject(cell);

    if (newCellData.machine === null && machines.length > 0) {
      newCellData.machine = machines[0].code;
    }

    setEditableCell(newCellData);
  }, [cell, machines]);

  const onAccept = () => {
    cell.title = editableCell.title;
    cell.machine = editableCell.machine;
    cell.variables = editableCell.variables.filter(x => x.field !== "");
    cell.events = editableCell.events.filter(x => x.field !== "");
    cell.indicatorMode = editableCell.indicatorMode;
    cell.indicatorRealtime = editableCell.indicatorRealtime ?? false;
    cell.stackedAxes = editableCell.stackedAxes;
    setOpen(false);
  };

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
      <DialogTitle id="customized-dialog-title">
        Chart Config
      </DialogTitle>
      <DialogContent dividers={true}>
        <AcqConfigPanel schema={schema} setEditableCell={setEditableCell} editableCell={editableCell} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary" startIcon={<CheckIcon/>}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon/>}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogAcqConfigCell;
